<template>
	<div class="assets-shortHistory-wrapper w-100">
		<Loading v-if="loading" class="mt-5"/>
		<template v-if="shortHistory !== null && loading === false">
			<div class="price-wrapper d-flex align-items-end">
				<strong
					>{{ shortHistory.total | price }}
					<small>{{ shortHistory.currency }}</small>
				</strong>
				<span class="ml-auto percent" :class="shortHistory.trend >= 0 ? 'percent-positive' : 'percent-negative'">{{ shortHistory.trend | number }} %</span>
			</div>
			<div class="date-wrapper">k {{ shortHistory.date | date }}</div>
			<div class="chart-wrapper clearfix">
				<vue-chart type="line" :data="chartData" :options="options" />
			</div>
		</template>
	</div>
</template>

<script>
import VueChart from "vue-chart-js";
import Loading from "./Loading";
import { assetsHistoryToChartData } from "../store/helpers";
import {formatPrice} from "@/utils";

const axes = {
	display: true,
	scaleLabel: {
		display: true,
	},
	gridLines: {
		drawOnChartArea: false,
		color: "#3c3c3c",
		drawTicks: false,
		lineWidth: 1,
	},
	ticks: {
		display: false,
	},
};

export default {
	name: "AssetsTrends",
	components: {
		Loading,
		VueChart,
	},
	computed: {
		shortHistory() {
			return this.$store.state.assets.shortHistory;
		},
		loading() {
			return this.$store.state.assets.loadingShortHistory;
		},
	},
	watch: {
		shortHistory: {
			deep: true,
			handler(newValue) {
				this.chartData.labels = [];
				this.chartData.datasets[0].data = [];

				if (newValue !== null) {
					const { labels, data } = assetsHistoryToChartData(newValue.history);

					this.chartData.labels = labels;
					this.chartData.datasets[0].data = data;
				}
			},
		},
	},
	mounted() {
		this.$store.dispatch("assets/loadShortHistory");
	},
	data: () => {
		return {
			chartData: {
				labels: [],
				datasets: [
					{
						borderColor: "#009dff",
						backgroundColor: "transparent",
						borderWidth: 2,
						data: [],
					},
				],
			},
			options: {
				responsive: true,
				title: {
					display: false,
				},
				tooltips: {
					mode: "index",
					intersect: false,
					custom: function(tooltip) {
						if (!tooltip) {
							return;
						}
						tooltip.displayColors = false;
					},
					callbacks: {
						// use label callback to return the desired label
						label: function(tooltipItem, data) {
							return tooltipItem.xLabel + ": " + formatPrice(tooltipItem.yLabel) + ' EUR';
						},
						// remove title
						title: function(tooltipItem, data) {
							return "";
						},
					},
				},
				legend: {
					display: false,
				},
				hover: {
					mode: "nearest",
					intersect: true,
				},
				elements: {
					point: {
						radius: 0,
					},
				},
				scales: {
					xAxes: [{ ...axes }],
					yAxes: [{ ...axes }],
				},
				layout: {
					padding: {
						left: 0,
						right: 20,
						top: 20,
						bottom: 0,
					},
				},
        maintainAspectRatio: false
			},
		};
	},
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.assets-shortHistory-wrapper {
	.price-wrapper {
		line-height: 24px;

		.percent {
			font-weight: bold;
		}

        .percent-positive {
          color: $success;
        }

        .percent-negative {
          color: $danger;
        }

		strong {
			font-size: 22px;

			small {
				font-size: 16px;
			}
		}
	}

	.date-wrapper {
		color: $secondary-text;
		font-size: 13px;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.chart-wrapper {
		margin: 0 -20px -20px;

		canvas {
			background: $secondary-bg !important;
			/*background: #fff ! important;*/
			box-shadow: none !important;
		}
	}
}
</style>
